import z from 'zod'

export const DecisionSchema = z.enum(['accepted', 'rejected'], {
  message: 'Please select a decision.',
})
